import Container from '@mui/material/Container';

import { styled } from '@mui/material/styles';

import { CustomBox, Link } from '../CustomComp';
import { LinkExternalCustom, LinkCustom } from '../customComponent/link';
import { THIS_YEAR } from '../../utils/date';
import * as urlConstants from '../../constants/url';

const Footer = styled('footer')({

  padding: '4px 0',
  fontSize: '10px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
})

const Copyright = (props) => {
  return (
    <CustomBox
      sx={{
        position: 'absolute',
        bottom: 0,
        width: '100%',
        paddingTop: 0,
        paddingBottom: 0,
      }}
    >
      <Container maxWidth="false">
        <Footer style={props.style}>
          <p>Copyright {THIS_YEAR} HAI INC. All rights reserved.</p>

          <LinkExternalCustom
            style={props.style}
            href="user-terms"
            target="_blank"
            sx={{ ml: '10px' }}>
            服務條款
          </LinkExternalCustom>

          <LinkExternalCustom
            style={props.style}
            href="privacy"
            target="_blank"
            sx={{ ml: '10px' }}>
            隱私權政策
          </LinkExternalCustom>

        </Footer>
      </Container>
    </CustomBox>
  )
}

export default Copyright;